import { createFileRoute } from '@tanstack/react-router';
import AuthErrorPage from 'src/features/plugins/outlook/(auth)/auth-error/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/auth-error')({
  component: AuthErrorPage,
});
